import React from 'react';
import DriverVerificationForm from './components/DriverVerificationForm';

function App() {
  return (
    <div>
      <DriverVerificationForm />
    </div>
  );
}

export default App;